import { AUTH_STORAGE_KEYS } from '@core/multi-tenant-auth';

/**
 * Reads the `fromAlliantPortal` query parameter from the initial URL and
 * persists it to session storage so the institution portal header can show
 * a "Back to Alliant Portal" button throughout the session.
 */
export function captureAlliantPortalOrigin(storage: Pick<Storage, 'setItem'>, win: Pick<Window, 'location'>): void {
  if (new URLSearchParams(win.location.search).get('fromAlliantPortal') === 'true') {
    storage.setItem(AUTH_STORAGE_KEYS.accessedFromAlliantPortal, 'true');
  }
}
